import { createSelector } from 'reselect'
import { State } from '../../reducers/reducerType'
import selectEnabledVideoTracks from '../selectEnabledVideoTracks'
import isScreenshareTrack from '../../../lib/isScreenshareTrack'
import { LocalVideoTrackPublication, RemoteVideoTrackPublication } from 'twilio-video'


/**
 * Filters tracks to get everything except screenshare tracks
 * @param state The Redux state
 */
const filterTracks = (videoTracks: Map<string, (LocalVideoTrackPublication | RemoteVideoTrackPublication)>): string[] => {

  const tracks: any[] = []

  for (const [ trackSid, track ] of videoTracks.entries()) {

    if (!isScreenshareTrack(track)) tracks.push(trackSid)

  }

  return tracks

}

/**
 * Fetches the tracks from the presenter
 * @param state The Redux state
 */
const getTracksByPresenter = (state: State, props): string[] => {

  if (!state.room.room) return []

  if (state.room.room.localParticipant.identity === props.presenter.BTID) return filterTracks(state.room.room.localParticipant.videoTracks)

  for (const participant of state.room.room.participants.values()) {

    if (participant.identity === props.presenter.BTID) {

      return filterTracks(participant.videoTracks)

    }

  }

  return []

}

export default createSelector(
  [
    selectEnabledVideoTracks,
    getTracksByPresenter
  ],
  (enabledTracks, presentersTracks) => {

    const tracks: any[] = []

    for (const track of enabledTracks) {

      if (presentersTracks.includes(track.trackSid)) {

        tracks.push(track)

      }

    }

    return tracks

  })
